// package.json sets "homepage": "./", so in production CRA emits imported
// assets as relative paths (e.g. "static/media/good-karma.<hash>.png").
// When that path is put in a CSS custom property (style="--bg-image: url(...)")
// the browser resolves it against the stylesheet that uses var(), not the page,
// so it 404s (e.g. /static/css/static/media/...). Making it root-absolute fixes
// that. Absolute URLs, protocol-relative URLs and data: URIs are left alone.
const toRootUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  if (/^([a-z][a-z0-9+.-]*:|\/\/|\/)/i.test(url)) return url;
  return "/" + url.replace(/^\.\//, "");
};

export default toRootUrl;
